import { Box, Tooltip, IconButton } from "@mui/material";
import dayjs from "dayjs";
import { orderFlagColor } from "../../utils/Constant";
import OrderFlag from "./order-flag";

export default function OrderTableFlagsCell({ rowData }: any) {
  const queueUpdatedDiff = Math.floor(
    Math.abs(dayjs(rowData.queueUpdatedAt).diff(Date.now(), "day", true))
  );
  const clientDueDateDiff = Math.ceil(
    dayjs(rowData.clientDueDate).diff(Date.now(), "day", true)
  );
  return (
    <Box sx={{ display: "flex", alignItems: "center", height: "inherit" }}>
      {rowData?.client?.isVip ? (
        <Tooltip title="VIP Client" arrow placement="top">
          <IconButton sx={{ p: 0, mr: 0.5 }}>
            <OrderFlag color={orderFlagColor.vipClient} />
          </IconButton>
        </Tooltip>
      ) : (
        <IconButton sx={{ p: 0, mr: 0.5 }}>
          <OrderFlag outline={true} color={orderFlagColor.vipClient} />
        </IconButton>
      )}
      {queueUpdatedDiff > 13 ? (
        <Tooltip
          title={`Status Hasn’t Changed in ${queueUpdatedDiff} Days`}
          arrow
          placement="top"
        >
          <IconButton sx={{ p: 0, mr: 0.5 }}>
            <OrderFlag color={orderFlagColor.statusNotChanged} />
          </IconButton>
        </Tooltip>
      ) : (
        <IconButton sx={{ p: 0, mr: 0.5 }}>
          <OrderFlag outline={true} color={orderFlagColor.statusNotChanged} />
        </IconButton>
      )}
      {rowData.isRushInspection ? (
        <Tooltip title="Rush Inspection" arrow placement="top">
          <IconButton sx={{ p: 0, mr: 0.5 }}>
            <OrderFlag color={orderFlagColor.rush} />
          </IconButton>
        </Tooltip>
      ) : (
        <IconButton sx={{ p: 0, mr: 0.5 }}>
          <OrderFlag outline={true} color={orderFlagColor.rush} />
        </IconButton>
      )}
      {clientDueDateDiff > 0 && clientDueDateDiff < 12 ? (
        <Tooltip
          title={`Due in ${clientDueDateDiff} Days`}
          arrow
          placement="top"
        >
          <IconButton sx={{ p: 0, mr: 0.5 }}>
            <OrderFlag color={orderFlagColor.dueDate} />
          </IconButton>
        </Tooltip>
      ) : (
        <IconButton sx={{ p: 0, mr: 0.5 }}>
          <OrderFlag outline={true} color={orderFlagColor.dueDate} />
        </IconButton>
      )}
      {rowData.hasOpenIssue ? (
        <Tooltip title="Open Issue" arrow placement="top">
          <IconButton sx={{ p: 0, mr: 0.5 }}>
            <OrderFlag color={orderFlagColor.openIssue} />
          </IconButton>
        </Tooltip>
      ) : (
        <IconButton sx={{ p: 0, mr: 0.5 }}>
          <OrderFlag outline={true} color={orderFlagColor.openIssue} />
        </IconButton>
      )}
      {clientDueDateDiff < 0 ? (
        <Tooltip title="Past Due" arrow placement="top">
          <IconButton sx={{ p: 0, mr: 0.5 }}>
            <OrderFlag color={orderFlagColor.pastDue} />
          </IconButton>
        </Tooltip>
      ) : (
        <IconButton sx={{ p: 0, mr: 0.5 }}>
          <OrderFlag outline={true} color={orderFlagColor.pastDue} />
        </IconButton>
      )}
    </Box>
  );
}
